
import { Component, Prop, Vue } from "vue-property-decorator";
import { calculateDistance } from "../../utils/util";
import { clearStoreSearchHistory } from "../../api/industryMall";
export const dimensionOption = [
  // 0:微店,1:门店
  { text: "总览", value: "" },
  { text: "门店", value: "1" },
  { text: "微店", value: "0" },
];
@Component
export default class DimensionSelect extends Vue {
  @Prop({ default: "门店" }) defaultValue?: string;
  @Prop({ default: false }) onlyShowTotal?: boolean; // 仅显示总览
  @Prop({ default: true }) showTotal?: boolean; // 是否显示总览

  options = [];

  defaultIndex = 1;
  show = false;
  openPop() {
    this.defaultIndex = this.options.findIndex(
      (item) => item.text === this.defaultValue
    );
    this.show = true;
  }
  onChange(picker, value, index) {
    // console.log("当前值", value, index);
    this.defaultIndex = index;
  }

  popupClose() {
    this.show = false;
  }

  confirmFn() {
    const name = this.options[this.defaultIndex];
    this.$emit("confirm", name.text || "", name.value);
    this.popupClose();
  }
  setOptions() {
    if (this.onlyShowTotal) {
      this.options = dimensionOption.filter((item) => item.text === "总览");
      return;
    }
    if (this.showTotal) {
      this.options = dimensionOption;
      return;
    }
    this.options = dimensionOption.filter((item) => item.text !== "总览");
  }
  mounted() {
    this.setOptions();
  }
}
